import { Box, SimpleGrid} from "@chakra-ui/react";
import JournalListTable from "./components/JournalListTable";

const JournalList = () => 
{

    return (                         

        <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>


            <SimpleGrid>
                <JournalListTable/>
            </SimpleGrid>
        </Box>       
    );

};
  
export default JournalList;
